module.exports = __webpack_public_path__ + "img/bg_register_volunteer_small.7304475f.jpg";